import TypeUtils from '@/helpers/type-utils';
import BaseModel from '@/data/models/base/base-model';
import dayjs from "dayjs";

export enum ClientStatus {
  active = 'active',
  inactive = 'inactive',
  deleted = 'deleted',
}

export default class Client extends BaseModel {

  public name: string;
  public surname: string;
  public phone: string;
  public email: string;
  public description: string;
  public createdAt: Date;
  public updatedAt: Date;
  public status: ClientStatus;
  public initialPassword?: string;

  public static map(data: Partial<Client>): Client {
    if (!data) {
      return null;
    }

    const client = new Client();

    client.id = TypeUtils.hasStringOrDefault(data.id);
    client.name = TypeUtils.hasStringOrDefault(data.name);
    client.surname = TypeUtils.hasStringOrDefault(data.surname);
    client.phone = TypeUtils.hasStringOrDefault(data.phone);
    client.email = TypeUtils.hasStringOrDefault(data.email);
    client.description = TypeUtils.hasStringOrDefault(data.description);
    client.createdAt = TypeUtils.hasDateOrDefault(data.createdAt, dayjs().toDate());
    client.status = TypeUtils.hasEnumOrDefault<ClientStatus>(data.status, ClientStatus, ClientStatus.active);
    client.initialPassword = TypeUtils.hasStringOrDefault(data.initialPassword, null);

    return client;
  }

  public toJSON(): { id: null; name: string; surname: string; phone: string; email: string; description: string; status: ClientStatus } {
    return {
      'id': null,
      'name': this.name,
      'surname': this.surname,
      'phone': this.phone,
      'email': this.email,
      'description': this.description,
      'status': this.status,
    };
  }

  get nameSurname(): string {
    return `${this.name} ${this.surname}`;
  }
}
